<span
  [class.row]="inline"
  *ngIf="control"
  #container
>
  <label class="form-label" *ngIf="label"
         [for]="name"
         [class.col-form-label]="inline"
         [class.col-form-label-sm]="inline && small"
         [class.col-sm-3]="inline"

  >{{ label }}
    <i *ngIf="multiSelectIsLoading" class="fa-a fa fa-spin fa-spinner"></i>
    <ng-container *ngIf="tooltipText">
      <span><i [tooltip]="tooltipText" class="fa fa-info-circle"></i></span>
    </ng-container>
  </label>

  <div [class.col-sm-9]="inline">

  <div class="input-group has-validation">
    <span *ngIf="prefix" class="input-group-text">
      {{ prefix }}
    </span>

    <ng-multiselect-dropdown
      [placeholder]="placeholder ?? ('forms.multiselect.placeholder' | translate)"
      (onFilterChange)="multiSelectSearchFilterChanged.next($any($event))"
      [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
      [class.is-valid]="control.touched && control.valid"
      [class.single-selection]="!multi"
      [settings]="{
        singleSelection: !multi,
        idField: 'id',
        textField: 'text',
        disabledField:  'isDisabled',
        enableCheckAll: true,
        selectAllText: 'forms.multiselect.select_all' | translate,
        unSelectAllText: 'forms.multiselect.unselect_all' | translate,
        allowSearchFilter: true,
        clearSearchFilter: false,
        maxHeight: 300,
        itemsShowLimit: Infinity,
        limitSelection: Infinity,
        searchPlaceholderText: 'forms.multiselect.search_placeholder' | translate,
        noDataAvailablePlaceholderText: 'forms.multiselect.no_data_available' | translate,
        noFilteredDataAvailablePlaceholderText: 'forms.multiselect.no_filtered_data_available' | translate,
        closeDropDownOnSelection: false,
        showSelectedItemsAtTop: true,
        defaultOpen: false,
        allowRemoteDataSearch: true
      }"
      (onSelect)="selectionChanged()"
      (onDeSelect)="selectionChanged()"
      (onSelectAll)="selectionChanged()"
      (onDeSelectAll)="selectionChanged()"
      [data]="allSelectOptions"
      class="w-100"
      [id]="label"
      [(ngModel)]="selectedItems"
      [disabled]="control.disabled"
    ></ng-multiselect-dropdown>

    <div class="invalid-feedback" *ngIf="!!control.getError('serverError')">{{ control.getError('serverError') }}</div>


    <ng-container *ngFor="let err of control.errors | keyvalue">
      <ng-container *ngIf="(control.touched && control.invalid)">
        <div *ngIf="errorMessages && errorMessages[err.key] " class="invalid-feedback">
          {{ errorMessages[err.key] }}
        </div>
        <div *ngIf="(!errorMessages || !errorMessages[err.key] ) && err.key !== 'serverError'" class="invalid-feedback">
          {{ 'forms.errors.' + err.key | translate }}
        </div>
      </ng-container>

    </ng-container>


  </div>
  </div>
</span>
